import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import * as Types from '@eluve/graphql-types';

export type AddUserToTenantzMutationVariables = Types.Exact<{
  tenantId: Types.Scalars['uuid']['input'];
  userId: Types.Scalars['uuid']['input'];
  role: Types.Scalars['String']['input'];
}>;

export type AddUserToTenantzMutation = {
  __typename?: 'mutation_root';
  insertTenantUsersOne: {
    __typename?: 'TenantUsers';
    createdAt: string;
    tenantId: string;
    userId: string;
  } | null;
};

export type AppointmentNameFragment = {
  __typename?: 'Appointments';
  name: string;
};

export type TenantUserRoleFragment = {
  __typename?: 'TenantUsers';
  role: string | null;
};

export type GetTenantUsersQueryVariables = Types.Exact<{
  tenantId: Types.Scalars['uuid']['input'];
}>;

export type GetTenantUsersQuery = {
  __typename?: 'query_root';
  tenantUsers: Array<{
    __typename: 'TenantUsers';
    tenantId: string;
    userId: string;
    createdAt: string;
    lastAccessedAt: string;
    role: string | null;
    user: {
      __typename?: 'Users';
      firstName: string;
      lastName: string;
      email: string;
    };
  }>;
};

export type UpdateUserTenantRoleMutationVariables = Types.Exact<{
  tenantId: Types.Scalars['uuid']['input'];
  userId: Types.Scalars['uuid']['input'];
  role: Types.Scalars['String']['input'];
}>;

export type UpdateUserTenantRoleMutation = {
  __typename?: 'mutation_root';
  updateTenantUsersByPk: {
    __typename: 'TenantUsers';
    tenantId: string;
    userId: string;
    role: string | null;
  } | null;
};

export type GetFullAuditTrailQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type GetFullAuditTrailQuery = {
  __typename?: 'query_root';
  auditTrail: Array<{
    __typename?: 'AuditTrail';
    id: string;
    createdAt: string;
    operation: string;
    data: Record<string, any> | null;
    tableName: string | null;
    user: {
      __typename?: 'Users';
      firstName: string;
      lastName: string;
      email: string;
      id: string;
    } | null;
  }>;
};

export type AppointmentTranscriptionFragment = {
  __typename?: 'Appointments';
  transcription: {
    __typename: 'AppointmentTranscripts';
    id: string;
    transcript: string | null;
    updatedAt: string;
  } | null;
};

export type UpdateAppointmentPatientMutationVariables = Types.Exact<{
  tenantId: Types.Scalars['uuid']['input'];
  id: Types.Scalars['uuid']['input'];
  patientId: Types.Scalars['uuid']['input'];
}>;

export type UpdateAppointmentPatientMutation = {
  __typename?: 'mutation_root';
  updateAppointmentsByPk: {
    __typename: 'Appointments';
    id: string;
    patient: { __typename: 'Patients'; id: string } | null;
  } | null;
};

export type UpdateAppointmentLocationMutationVariables = Types.Exact<{
  tenantId: Types.Scalars['uuid']['input'];
  appointmentId: Types.Scalars['uuid']['input'];
  locationId: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;

export type UpdateAppointmentLocationMutation = {
  __typename?: 'mutation_root';
  updateAppointmentsByPk: {
    __typename: 'Appointments';
    id: string;
    locationId: string | null;
  } | null;
};

export type InsertAppointmentAudioFileMutationVariables = Types.Exact<{
  appointmentId: Types.Scalars['uuid']['input'];
  fileId: Types.Scalars['uuid']['input'];
  fileType: Types.AppointmentFileTypesEnum;
}>;

export type InsertAppointmentAudioFileMutation = {
  __typename?: 'mutation_root';
  insertAppointmentFilesOne: {
    __typename: 'AppointmentFiles';
    appointmentId: string;
    fileId: string;
    userUpload: {
      __typename: 'UserUploads';
      id: string;
      status: Types.UserUploadStatusEnum;
    };
  } | null;
};

export type UserUploadFragment = {
  __typename: 'UserUploads';
  id: string;
  status: Types.UserUploadStatusEnum;
};

export type AppointmentFileFragment = {
  __typename: 'AppointmentFiles';
  appointmentId: string;
  fileId: string;
};

export type UserUploadedAppointmentFileFragment = {
  __typename: 'AppointmentFiles';
  appointmentId: string;
  fileId: string;
  userUpload: {
    __typename: 'UserUploads';
    id: string;
    status: Types.UserUploadStatusEnum;
  };
};

export type UserUploadedAppointmentFilesFragment = {
  __typename?: 'Appointments';
  appointmentFiles: Array<{
    __typename: 'AppointmentFiles';
    appointmentId: string;
    fileId: string;
    userUpload: {
      __typename: 'UserUploads';
      id: string;
      status: Types.UserUploadStatusEnum;
    };
  }>;
};

export type InsertUserUploadMutationVariables = Types.Exact<{
  [key: string]: never;
}>;

export type InsertUserUploadMutation = {
  __typename?: 'mutation_root';
  insertUserUploadsOne: {
    __typename: 'UserUploads';
    id: string;
    status: Types.UserUploadStatusEnum;
  } | null;
};

export type UpdateUserUploadMutationVariables = Types.Exact<{
  tenantId: Types.Scalars['uuid']['input'];
  gcsFilePath: Types.InputMaybe<Types.Scalars['String']['input']>;
  id: Types.Scalars['uuid']['input'];
  status: Types.UserUploadStatusEnum;
}>;

export type UpdateUserUploadMutation = {
  __typename?: 'mutation_root';
  updateUserUploadsByPk: {
    __typename: 'UserUploads';
    id: string;
    status: Types.UserUploadStatusEnum;
  } | null;
};

export type ReassignAppointmentOwnerMutationVariables = Types.Exact<{
  tenantId: Types.Scalars['uuid']['input'];
  appointmentId: Types.Scalars['uuid']['input'];
  newOwnerId: Types.Scalars['uuid']['input'];
}>;

export type ReassignAppointmentOwnerMutation = {
  __typename?: 'mutation_root';
  updateAppointmentsByPk: {
    __typename: 'Appointments';
    id: string;
    userId: string | null;
    user: {
      __typename: 'Users';
      id: string;
      firstName: string;
      lastName: string;
      email: string;
    } | null;
  } | null;
};

export type CreateTranscriptMutationVariables = Types.Exact<{
  appointmentId: Types.Scalars['uuid']['input'];
  audioFileId: Types.Scalars['uuid']['input'];
  segmentId: Types.Scalars['uuid']['input'];
  transcriptType: Types.TranscriptTypesEnum;
}>;

export type CreateTranscriptMutation = {
  __typename?: 'mutation_root';
  insertTranscriptsOne: {
    __typename: 'Transcripts';
    id: string;
    transcript: string | null;
    transcriptionStatus: Types.TranscriptionStatusEnum;
  } | null;
};

export type InsertUserEventWithMetadataMutationVariables = Types.Exact<{
  eventName: Types.UserEventNamesEnum;
  metadata: Types.InputMaybe<Types.Scalars['jsonb']['input']>;
}>;

export type InsertUserEventWithMetadataMutation = {
  __typename?: 'mutation_root';
  insertUserEventsOne: { __typename: 'UserEvents'; id: string } | null;
};

export type InsertUserEventWithoutMetadataMutationVariables = Types.Exact<{
  eventName: Types.UserEventNamesEnum;
}>;

export type InsertUserEventWithoutMetadataMutation = {
  __typename?: 'mutation_root';
  insertUserEventsOne: { __typename: 'UserEvents'; id: string } | null;
};

export type GetTranscriptsForAppointmentQueryVariables = Types.Exact<{
  appointmentId: Types.Scalars['uuid']['input'];
}>;

export type GetTranscriptsForAppointmentQuery = {
  __typename?: 'query_root';
  transcripts: Array<{
    __typename?: 'Transcripts';
    id: string;
    chunkNum: number | null;
    transcript: string | null;
    transcriptionStatus: Types.TranscriptionStatusEnum;
    transcriptionCompletedAt: string | null;
  }>;
};

export type GetLatestTranscriptForAppointmentQueryVariables = Types.Exact<{
  appointmentId: Types.Scalars['uuid']['input'];
}>;

export type GetLatestTranscriptForAppointmentQuery = {
  __typename?: 'query_root';
  transcripts: Array<{
    __typename?: 'Transcripts';
    id: string;
    chunkNum: number | null;
    transcriptionStatus: Types.TranscriptionStatusEnum;
  }>;
};

export type GetFeedbackTagsQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type GetFeedbackTagsQuery = {
  __typename?: 'query_root';
  feedbackTags: Array<{
    __typename: 'FeedbackTags';
    id: number;
    name: string;
    type: Types.FeedbackTypeEnum | null;
  }>;
};

export type ListenTranscriptsSubscriptionVariables = Types.Exact<{
  appointmentId: Types.Scalars['uuid']['input'];
}>;

export type ListenTranscriptsSubscription = {
  __typename?: 'subscription_root';
  transcripts: Array<{
    __typename: 'Transcripts';
    id: string;
    transcriptionStatus: Types.TranscriptionStatusEnum;
  }>;
};

export type LocationFragment = {
  __typename: 'Locations';
  id: string;
  name: string;
  path: string;
  depth: number;
  isRoot: boolean;
  timezone: string | null;
  tenantId: string;
  externalEhrId: string | null;
  address: string | null;
  logoUrl: string | null;
  phoneNumber: string | null;
  externalId: string | null;
  businessName: string | null;
  placeOfServiceCode: string | null;
  taxId: string | null;
};

export type ExternalEhrFragment = {
  __typename: 'ExternalEhr';
  id: string;
  vendor: Types.VendorTypesEnum;
  domain: string;
};

export type LocationsLayerExternalEhrFragment = {
  __typename: 'Locations';
  id: string;
  name: string;
  path: string;
  depth: number;
  isRoot: boolean;
  timezone: string | null;
  tenantId: string;
  externalEhrId: string | null;
  address: string | null;
  logoUrl: string | null;
  phoneNumber: string | null;
  externalId: string | null;
  businessName: string | null;
  placeOfServiceCode: string | null;
  taxId: string | null;
  layer: { __typename?: 'Layers'; id: string; name: string };
  externalEhr: {
    __typename: 'ExternalEhr';
    id: string;
    vendor: Types.VendorTypesEnum;
    domain: string;
  } | null;
};

export type TenantLocationsAndExternalEhrsFragment = {
  __typename?: 'Tenants';
  locations: Array<{
    __typename: 'Locations';
    id: string;
    name: string;
    path: string;
    depth: number;
    isRoot: boolean;
    timezone: string | null;
    tenantId: string;
    externalEhrId: string | null;
    address: string | null;
    logoUrl: string | null;
    phoneNumber: string | null;
    externalId: string | null;
    businessName: string | null;
    placeOfServiceCode: string | null;
    taxId: string | null;
    externalEhr: {
      __typename: 'ExternalEhr';
      id: string;
      vendor: Types.VendorTypesEnum;
      domain: string;
    } | null;
  }>;
};

export type GetUserLocationsQueryVariables = Types.Exact<{
  tenantId: Types.Scalars['uuid']['input'];
}>;

export type GetUserLocationsQuery = {
  __typename?: 'query_root';
  tenantsByPk: {
    __typename: 'Tenants';
    id: string;
    locations: Array<{
      __typename: 'Locations';
      id: string;
      name: string;
      path: string;
      depth: number;
      isRoot: boolean;
      timezone: string | null;
      tenantId: string;
      externalEhrId: string | null;
      address: string | null;
      logoUrl: string | null;
      phoneNumber: string | null;
      externalId: string | null;
      businessName: string | null;
      placeOfServiceCode: string | null;
      taxId: string | null;
      layer: { __typename?: 'Layers'; id: string; name: string };
      externalEhr: {
        __typename: 'ExternalEhr';
        id: string;
        vendor: Types.VendorTypesEnum;
        domain: string;
      } | null;
    }>;
  } | null;
};

export const AppointmentNameFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AppointmentName' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Appointments' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
      },
    },
  ],
} as unknown as DocumentNode<AppointmentNameFragment, unknown>;
export const TenantUserRoleFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TenantUserRole' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TenantUsers' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'role' } }],
      },
    },
  ],
} as unknown as DocumentNode<TenantUserRoleFragment, unknown>;
export const AppointmentTranscriptionFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'appointmentTranscription' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Appointments' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transcription' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'transcript' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AppointmentTranscriptionFragment, unknown>;
export const AppointmentFileFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AppointmentFile' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AppointmentFiles' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'appointmentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fileId' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AppointmentFileFragment, unknown>;
export const UserUploadFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserUpload' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserUploads' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UserUploadFragment, unknown>;
export const UserUploadedAppointmentFileFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserUploadedAppointmentFile' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AppointmentFiles' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'AppointmentFile' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userUpload' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'UserUpload' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AppointmentFile' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AppointmentFiles' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'appointmentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fileId' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserUpload' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserUploads' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UserUploadedAppointmentFileFragment, unknown>;
export const UserUploadedAppointmentFilesFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserUploadedAppointmentFiles' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Appointments' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appointmentFiles' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'UserUploadedAppointmentFile' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AppointmentFile' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AppointmentFiles' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'appointmentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fileId' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserUpload' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserUploads' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserUploadedAppointmentFile' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AppointmentFiles' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'AppointmentFile' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userUpload' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'UserUpload' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UserUploadedAppointmentFilesFragment, unknown>;
export const LocationFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Location' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Locations' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'path' } },
          { kind: 'Field', name: { kind: 'Name', value: 'depth' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isRoot' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'externalEhrId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address' } },
          { kind: 'Field', name: { kind: 'Name', value: 'logoUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'businessName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'placeOfServiceCode' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'taxId' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LocationFragment, unknown>;
export const ExternalEhrFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ExternalEhr' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ExternalEhr' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'vendor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'domain' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ExternalEhrFragment, unknown>;
export const LocationsLayerExternalEhrFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'LocationsLayerExternalEhr' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Locations' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Location' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'layer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'externalEhr' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ExternalEhr' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Location' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Locations' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'path' } },
          { kind: 'Field', name: { kind: 'Name', value: 'depth' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isRoot' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'externalEhrId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address' } },
          { kind: 'Field', name: { kind: 'Name', value: 'logoUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'businessName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'placeOfServiceCode' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'taxId' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ExternalEhr' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ExternalEhr' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'vendor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'domain' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LocationsLayerExternalEhrFragment, unknown>;
export const TenantLocationsAndExternalEhrsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TenantLocationsAndExternalEhrs' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Tenants' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'locations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Location' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'externalEhr' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ExternalEhr' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Location' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Locations' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'path' } },
          { kind: 'Field', name: { kind: 'Name', value: 'depth' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isRoot' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'externalEhrId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address' } },
          { kind: 'Field', name: { kind: 'Name', value: 'logoUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'businessName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'placeOfServiceCode' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'taxId' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ExternalEhr' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ExternalEhr' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'vendor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'domain' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TenantLocationsAndExternalEhrsFragment, unknown>;
export const AddUserToTenantzDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'addUserToTenantz' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'tenantId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'userId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'role' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'insertTenantUsersOne' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'object' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'tenantId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'tenantId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'userId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'userId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'role' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'role' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AddUserToTenantzMutation,
  AddUserToTenantzMutationVariables
>;
export const GetTenantUsersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getTenantUsers' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'tenantId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tenantUsers' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'tenantId' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'tenantId' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'TenantUserRole' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'lastAccessedAt' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'firstName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TenantUserRole' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TenantUsers' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'role' } }],
      },
    },
  ],
} as unknown as DocumentNode<GetTenantUsersQuery, GetTenantUsersQueryVariables>;
export const UpdateUserTenantRoleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateUserTenantRole' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'tenantId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'userId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'role' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateTenantUsersByPk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pkColumns' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'tenantId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'tenantId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'userId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'userId' },
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'role' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'role' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateUserTenantRoleMutation,
  UpdateUserTenantRoleMutationVariables
>;
export const GetFullAuditTrailDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getFullAuditTrail' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'auditTrail' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'orderBy' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'createdAt' },
                      value: { kind: 'EnumValue', value: 'DESC_NULLS_LAST' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'operation' } },
                { kind: 'Field', name: { kind: 'Name', value: 'data' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tableName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'firstName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetFullAuditTrailQuery,
  GetFullAuditTrailQueryVariables
>;
export const UpdateAppointmentPatientDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateAppointmentPatient' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'tenantId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'patientId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateAppointmentsByPk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pkColumns' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'tenantId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'tenantId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'patientId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'patientId' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'patient' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: '__typename' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateAppointmentPatientMutation,
  UpdateAppointmentPatientMutationVariables
>;
export const UpdateAppointmentLocationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateAppointmentLocation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'tenantId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'appointmentId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'locationId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateAppointmentsByPk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pkColumns' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'tenantId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'tenantId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'appointmentId' },
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'locationId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'locationId' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateAppointmentLocationMutation,
  UpdateAppointmentLocationMutationVariables
>;
export const InsertAppointmentAudioFileDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'insertAppointmentAudioFile' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'appointmentId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'fileId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'fileType' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AppointmentFileTypesEnum' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'insertAppointmentFilesOne' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'object' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'appointmentId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'appointmentId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fileId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'fileId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fileType' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'fileType' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'UserUploadedAppointmentFile' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AppointmentFile' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AppointmentFiles' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'appointmentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fileId' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserUpload' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserUploads' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserUploadedAppointmentFile' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AppointmentFiles' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'AppointmentFile' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userUpload' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'UserUpload' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  InsertAppointmentAudioFileMutation,
  InsertAppointmentAudioFileMutationVariables
>;
export const InsertUserUploadDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'insertUserUpload' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'insertUserUploadsOne' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'object' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'status' },
                      value: { kind: 'EnumValue', value: 'PENDING_UPLOAD' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'UserUpload' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserUpload' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserUploads' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  InsertUserUploadMutation,
  InsertUserUploadMutationVariables
>;
export const UpdateUserUploadDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateUserUpload' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'tenantId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'gcsFilePath' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'status' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UserUploadStatusEnum' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateUserUploadsByPk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pkColumns' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'tenantId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'tenantId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fileUrl' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'gcsFilePath' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'status' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'status' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uploadedAt' },
                      value: { kind: 'EnumValue', value: 'NOW' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'UserUpload' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserUpload' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserUploads' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateUserUploadMutation,
  UpdateUserUploadMutationVariables
>;
export const ReassignAppointmentOwnerDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'reassignAppointmentOwner' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'tenantId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'appointmentId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'newOwnerId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateAppointmentsByPk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pkColumns' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'tenantId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'tenantId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'appointmentId' },
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'userId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'newOwnerId' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: '__typename' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'firstName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ReassignAppointmentOwnerMutation,
  ReassignAppointmentOwnerMutationVariables
>;
export const CreateTranscriptDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createTranscript' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'appointmentId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'audioFileId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'segmentId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'transcriptType' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'TranscriptTypesEnum' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'insertTranscriptsOne' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'object' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'appointmentId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'appointmentId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'audioFileId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'audioFileId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'transcriptionStatus' },
                      value: { kind: 'EnumValue', value: 'NOT_STARTED' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'segmentId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'segmentId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'transcriptType' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'transcriptType' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'transcript' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'transcriptionStatus' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateTranscriptMutation,
  CreateTranscriptMutationVariables
>;
export const InsertUserEventWithMetadataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'insertUserEventWithMetadata' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'eventName' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UserEventNamesEnum' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'metadata' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'jsonb' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'insertUserEventsOne' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'object' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'eventName' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'eventName' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'metadata' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'metadata' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  InsertUserEventWithMetadataMutation,
  InsertUserEventWithMetadataMutationVariables
>;
export const InsertUserEventWithoutMetadataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'insertUserEventWithoutMetadata' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'eventName' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UserEventNamesEnum' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'insertUserEventsOne' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'object' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'eventName' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'eventName' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  InsertUserEventWithoutMetadataMutation,
  InsertUserEventWithoutMetadataMutationVariables
>;
export const GetTranscriptsForAppointmentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getTranscriptsForAppointment' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'appointmentId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transcripts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'appointmentId' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'appointmentId' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'orderBy' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'chunkNum' },
                      value: { kind: 'EnumValue', value: 'ASC' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'createdAt' },
                      value: { kind: 'EnumValue', value: 'ASC' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'chunkNum' } },
                { kind: 'Field', name: { kind: 'Name', value: 'transcript' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'transcriptionStatus' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'transcriptionCompletedAt' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetTranscriptsForAppointmentQuery,
  GetTranscriptsForAppointmentQueryVariables
>;
export const GetLatestTranscriptForAppointmentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getLatestTranscriptForAppointment' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'appointmentId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transcripts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'appointmentId' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'appointmentId' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'orderBy' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'chunkNum' },
                      value: { kind: 'EnumValue', value: 'DESC' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'createdAt' },
                      value: { kind: 'EnumValue', value: 'DESC' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'IntValue', value: '1' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'chunkNum' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'transcriptionStatus' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetLatestTranscriptForAppointmentQuery,
  GetLatestTranscriptForAppointmentQueryVariables
>;
export const GetFeedbackTagsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getFeedbackTags' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'feedbackTags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetFeedbackTagsQuery,
  GetFeedbackTagsQueryVariables
>;
export const ListenTranscriptsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'listenTranscripts' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'appointmentId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transcripts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'appointmentId' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'appointmentId' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'transcriptionStatus' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ListenTranscriptsSubscription,
  ListenTranscriptsSubscriptionVariables
>;
export const GetUserLocationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getUserLocations' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'tenantId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tenantsByPk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'tenantId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'locations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'LocationsLayerExternalEhr',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Location' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Locations' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'path' } },
          { kind: 'Field', name: { kind: 'Name', value: 'depth' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isRoot' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tenantId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'externalEhrId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address' } },
          { kind: 'Field', name: { kind: 'Name', value: 'logoUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'businessName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'placeOfServiceCode' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'taxId' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ExternalEhr' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ExternalEhr' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'vendor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'domain' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'LocationsLayerExternalEhr' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Locations' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Location' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'layer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'externalEhr' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ExternalEhr' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetUserLocationsQuery,
  GetUserLocationsQueryVariables
>;
